import React from 'react';

const LinkedInIcon = ({ className }) => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                d='M12 23.9995C18.6274 23.9995 24 18.6269 24 11.9995C24 5.37209 18.6274 -0.000488281 12 -0.000488281C5.37258 -0.000488281 0 5.37209 0 11.9995C0 18.6269 5.37258 23.9995 12 23.9995Z'
                fill='#007AB9'
            />
            <path
                d='M19.1699 12.9653V17.9127H16.3016V13.2969C16.3016 12.1379 15.8874 11.3465 14.8489 11.3465C14.0563 11.3465 13.5855 11.8793 13.3776 12.3953C13.3021 12.5797 13.2826 12.8357 13.2826 13.0943V17.9125H10.4141C10.4141 17.9125 10.4526 10.0949 10.4141 9.28563H13.2828V10.5081C13.2771 10.5178 13.2689 10.5272 13.2638 10.5364H13.2828V10.5081C13.664 9.92159 14.3438 9.08306 15.868 9.08306C17.7551 9.08306 19.1699 10.316 19.1699 12.9653ZM7.41332 5.1272C6.43211 5.1272 5.79016 5.77128 5.79016 6.61752C5.79016 7.44578 6.4135 8.10848 7.37567 8.10848H7.39428C8.39475 8.10848 9.0168 7.44578 9.0168 6.61752C8.99776 5.77128 8.39475 5.1272 7.41332 5.1272ZM5.96065 17.9127H8.82813V9.28563H5.96065V17.9127Z'
                fill='#F1F2F2'
            />
        </svg>
    );
};

export { LinkedInIcon };
